import Footer from 'components/Footer';
import Navbar from 'components/Navbar';
import React from 'react';
import styled from 'styled-components';
import DefaultContainer from 'styledComponents/DefaultContainer';
import {
	media,variables
} from 'styleUtils';

const CustomContainer = styled(DefaultContainer)`
  padding-top: 40px;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
`;

const Content = styled.div`
  background-color: ${variables.white};
  text-align: left;
  padding: 40px 20px 30px;

  ${media.tablet`
    padding: 60px;
  `}
`;

const Header = styled.h2`
  margin: 0;
  font-size: 1.75rem;
  line-height: 1.36;
  margin-bottom: 20px;

  ${media.tablet`
    margin-bottom: 30px;
  `}
`;

const Border = styled.div`
  width: 100%;
  height: 40px;
  background-color: ${variables.yellow};
`;

export const ErrorWindow = () => (
	<CustomContainer>
		<Content>
			<Header>Whoops!</Header>
			<p>
          We sincerely apologize - it appears that we're experiencing some technical difficulties.
				<br /><br />
          If this problem continues for you after refreshing the page, please email us at <a href='mailto:care@apostrophe.com' target='_blank' rel="noreferrer">care@apostrophe.com</a> and we'll get this resolved ASAP!
			</p>
		</Content>
		<Border />
	</CustomContainer>
)

const DefaultError = () => (
	<>
		<Navbar solid />
		<ErrorWindow />
		<Footer />
	</>
);

export default DefaultError;
